<i inlineSVG="/assets/icons/graphics-black.svg"></i>
<span>{{ name }}</span>
<span [ngClass]="{ included: number > 0 }">{{ number }}</span>
